export const WARNING_DESCRIPTION = 'This frame was originally purchased with Rx Lenses. Not all modifications may be available with a standard reader - confirm with the customer before proceeding!';

export enum RxStepSubtitleCopy {
  Progressives = 'Showing all progressives prescriptions',
  Readers = 'Showing all readers prescriptions',
  SingleVision = 'Showing all single-vision prescriptions',
  Default = 'Showing all valid prescriptions',
  Archived = 'The original Rx is archived, please select another',
}
